const { createContext } = require("react");


export const initialState = {
  profilePicSrc: '/img/user.svg',
  setProfilePicSrc: () => { }
}
const ProfileContext = createContext(initialState);

export default ProfileContext